namespace app.services.project {

  export class ProjectPasswordService implements IService {
    private readonly ItemResource;

    constructor(rootScope: IRootScope, $resource: angular.resource.IResourceService, configService: app.services.IConfigService, resourceWrapperService: app.services.utilities.ResourceWrapperService, tokenService: app.services.authentication.TokenService, httpService: app.services.IHttpWrapperService, private notificationService: app.services.INotificationService) {
      const projectPasswordResource = $resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/password/:id`,
        {"id": "@id", "projectId": "@projectId"},
        {"update": {method: "PUT"}});

      this.ItemResource = resourceWrapperService.WrapActions(projectPasswordResource);
    }

    public static async Save(newProjectPassword: angular.resource.IResourceClass<string>) {
      return (newProjectPassword as any).$save();
    }

    public async FindOne(id: string, projectId: string) {
      return this.ItemResource.get({id: id, projectId: projectId});
    }

    public async FindAll(projectId: string) {
      return this.ItemResource.query({projectId: projectId});
    }

    public Create(projectId: string, password: string): angular.resource.IResourceClass<string> {
      return new this.ItemResource({projectId, password});
    }

    public Delete(password, callback?: Function, errorCallback?: Function) {
      password.$delete((response, deleteResponseHeaders) => callback?.call(this, response), () => {
        this.notificationService.addError({
          title: "Error deleting password",
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });

        errorCallback?.call(this);
      });
    }
  }

  frontendApp.factory("ProjectPasswordService", ['$rootScope', '$resource', 'ConfigService', 'ResourceWrapperService', 'TokenService', 'HttpService', 'NotificationService', function(rootScope, resource, configService, resourceWrapperService, tokenService, httpService, notificationService) {
    return new ProjectPasswordService(rootScope, resource, configService, resourceWrapperService, tokenService, httpService, notificationService);
  }]);
}
